import React from 'react';
import { Typography } from 'antd';
import type { BaseFieldProps } from '../../../types/form-renderer';
import type {
  ImageMultiSelectField as ImageMultiSelectFieldType,
  VisualSelectOption
} from '../../../types/templates';
import { SearchGrid } from './visual-search-field/shared/search-grid';

const { Text } = Typography;

type Props = BaseFieldProps<ImageMultiSelectFieldType>;

export const ImageMultiSelectField: React.FC<Props> = ({ field, value, onChange, commonStyle, labelStyle, error }) => {
  const selected: VisualSelectOption[] = React.useMemo(() => (Array.isArray(value) ? value : []), [value]);
  const selectedValues = React.useMemo(() => new Set(selected.map(s => s.value)), [selected]);
  const options = React.useMemo(() => (Array.isArray(field.options) ? field.options : []), [field.options]);

  const maxSelections = field.maxSelections;
  const atMax = maxSelections !== undefined && selected.length >= maxSelections;

  const toggle = (optValue: string) => {
    if (selectedValues.has(optValue)) {
      onChange(selected.filter(s => s.value !== optValue));
      return;
    }
    if (atMax) return;
    const opt = options.find(o => o.value === optValue);
    if (!opt) return;
    onChange([...selected, opt]);
  };

  const getSlotForValue = (val: string): 1 | 2 | null => (selectedValues.has(val) ? 1 : null);

  return (
    <div style={commonStyle}>
      <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 8 }}>
        <Text type='secondary' style={{ ...labelStyle, textTransform: 'uppercase' }}>
          {field.label}
        </Text>
        {maxSelections !== undefined && (
          <Text type={atMax ? 'warning' : 'secondary'} style={{ fontSize: 12 }}>
            {selected.length}/{maxSelections}
          </Text>
        )}
      </div>

      <SearchGrid
        options={options}
        placeholder={field.placeholder}
        getSlotForValue={getSlotForValue}
        showPip={false}
        onCardClick={toggle}
      />

      {error && (
        <Text type='danger' style={{ fontSize: 12, marginTop: 6, display: 'block' }}>
          {error}
        </Text>
      )}
    </div>
  );
};
